import React from 'react';

const footer = (props) => (
   <div>
   </div>
);

export default footer;


// WEBPACK FOOTER //
// ./src/components/Navigation/Footer/Footer.js